<button class="normalize-button with-hover-effect">
  <app-ui-icon-x [iconName]="iconName" [size]="size"></app-ui-icon-x>
</button>
